import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// API
import infracoes_api from '../../../api/infracoes_api';

// Helpers
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from '../../../helpers/cookies';

// Context
import { useAuth } from '../../../context/auth';

// Components
import FichaInfracao from '../FichaInfracao';
import Loading from '../../../components/Loading/Loading';
import setup_api from '../../../api/setup_api';
import secretaria_api from '../../../api/secretaria_api';

function ConsultaFichaInfracaoViaLink() {
    // Objeto
    const session = getSessionCookie();

    // Pegar a queryString da URL
    const location = useLocation();

    // State para lista de infração
    const [infracao, setInfracao] = useState(null);

    const { setLoading, loading, setLogoSecretaria, setLogoSistema, setLogoPrefeitura } = useAuth();

    const loadLogoSecretaria = () => {
        secretaria_api.getLogotipo().then(response => {
            setLogoSecretaria(response.data);
        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadLogoTipos = () => {
        setup_api.GetLogotipos().then(response => {
            setLogoPrefeitura(response.data.logotipoPrefeitura);
            if (response.data.logotipoSistema)
                setLogoSistema(response.data.logotipoSistema);
        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadFichaInfracao = () => {
        const searchParams = new URLSearchParams(location.search);
        const hash = searchParams.get('hash');

        if (session != null) {
            showMessage("Error", "Esse acesso é exclusivo do infrator.", "error", null);
            setLoading(false);
            return;
        } else {
            setLoading(true);
            infracoes_api
                .GetItemFiscalizacaoHash(hash)
                .then(response => {
                    setInfracao(response.data)
                })
                .catch(error => showMessage("Error", error.message, "error", null))
                .finally(() => setLoading(false));
        }
    };

    useEffect(() => {
        loadLogoSecretaria();
        loadLogoTipos()
        loadFichaInfracao();
    }, []);

    return <>
        {loading && <Loading />}
        {infracao && <FichaInfracao fichaExterna={infracao} />}
    </>;
}

export default ConsultaFichaInfracaoViaLink;
